import { render, staticRenderFns } from "./BridgeHeader.vue?vue&type=template&id=a06da556&scoped=true"
import script from "./BridgeHeader.vue?vue&type=script&lang=js"
export * from "./BridgeHeader.vue?vue&type=script&lang=js"
import style0 from "./BridgeHeader.vue?vue&type=style&index=0&id=a06da556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06da556",
  null
  
)

export default component.exports